import "../icon.styles.css";

const HTMLIcon = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 250 250"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g id="Frame 1">
        <path
          className="shadow"
          id="Vector"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13 0H238L218.679 224.502L126.435 250L32.9446 224.502L13 0ZM126.435 20.5224H215.562L201.227 208.333L126.435 231.343V200.249L74.0803 182.214L70.3407 146.144H96.518L100.258 161.07L126.435 171.02L153.859 161.07V131.219H70.3407L66.6011 52.8607H126.435V20.5224Z"
          fill="#B9CCD2"
        />
        <path
          className="highlight"
          id="Vector_2"
          d="M215.562 20.5224H126.435V52.8607H188.139L183.776 78.3582H93.4017L96.518 104.478H183.776L178.789 182.214L126.435 200.249V231.343L201.227 208.333L215.562 20.5224Z"
          fill="#DEF7FF"
        />
      </g>
    </svg>
  );
};

export default HTMLIcon;
